import { ECC } from './ECC';

export const DEFAULT_ZLIB_COMPRESSION_LEVEL = 9;
export const DEFAULT_ECC_LEVEL = ECC.L;
export const COLOR_BLACK = '#000000';
export const COLOR_WHITE = '#FFFFFF';
export const DEFAULT_QR_SCALE = 10;
export const DEFAULT_QR_BORDER = 3;
export const DEFAULT_QR_QUALITY = 1;
export const ZIP_HEADER = 'PK';
export const DEFAULT_ZIP_FILE_NAME = 'certificate.json';

export const CLAIM_169_MAP = new Map<string, number>([
    ['id', 1],
    ['version', 2],
    ['language', 3],
    ['fullName', 4],
    ['firstName', 5],
    ['middleName', 6],
    ['lastName', 7],
    ['dob', 8],
    ['gender', 9],
    ['address', 10],
    ['email', 11],
    ['phone', 12],
    ['nationality', 13],
    ['maritalStatus', 14],
    ['guardian', 15],
    ['binaryImage', 16],
    ['binaryImageFormat', 17],
    ['bestQualityFingers', 18],
    ['rightThumb', 50],
    ['rightPointerFinger', 51],
    ['rightMiddleFinger', 52],
    ['rightRingFinger', 53],
    ['rightLittleFinger', 54],
    ['leftThumb', 55],
    ['leftPointerFinger', 56],
    ['leftMiddleFinger', 57],
    ['leftRingFinger', 58],
    ['leftLittleFinger', 59],
    ['rightIris', 60],
    ['leftIris', 61],
    ['face', 62],
    ['rightPalmPrint', 63],
    ['leftPalmPrint', 64],
    ['voice', 65],
]);